import { notification } from "antd";
import to from "await-to-js";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import style from "./RedirectLogin.module.scss";

import { ModalsContext } from "../../context/modals.context";
import { USER_REDIRECT_MAP } from "../../modules/auth/auth.constants";
import { AuthContext } from "../../modules/auth/auth.context";
import { authService } from "../../modules/auth/auth.service";
import storage from "../../utils/storage";

export const RedirectLogin = () => {
  const navigate = useNavigate();
  const { setAuth } = useContext(AuthContext);
  const { startLoader, endLoader, setError } = useContext(ModalsContext);

  const getUserRoles = async () => {
    const [err, res] = await to(authService.getUserRoles());
    if (err || !res.success) return setError(res?.errorMessage);

    const activeUserRoles = res.data.roles
      .filter((r) => r.aktivno)
      .map((r) => r.name);
    setAuth({
      allUserRoles: activeUserRoles,
      showAddDrustvo: res.data.showAddDrustvo,
    });

    startLoader();

    authService.setShowAddDrustvo(res.data.showAddDrustvo);
    authService.setRole(activeUserRoles);
    storage.setItem("userCompanyId", res.data?.selectedDrustvoId as any);

    setTimeout(() => {
      endLoader();
      // Todo: redirect user according to role

      const getPath = () => {
        let redirectPath = "";
        activeUserRoles.forEach((activeRole: string) => {
          // @ts-ignore
          const roleRedirectPath = USER_REDIRECT_MAP[activeRole];
          if (roleRedirectPath && !redirectPath) {
            redirectPath = roleRedirectPath;
          }
        });
        return redirectPath;
      };
      getPath() ? navigate(getPath()) : navigate("/chooseCompany");
    }, 4000);
    notification.success({
      message: "Uspešno ste ulogovani!",
    });
  };

  useEffect(() => {
    getUserRoles();
  }, []);

  return (
    <div className={style.container}>
      <h1 className={style.loginTitle}>eAkcize</h1>
      <p className={style.text}>
        Uskoro ćete biti preusmereni na aplikaciju...
      </p>
    </div>
  );
};
